
import { IoMdCart } from "react-icons/io";
import { MdShoppingBag } from "react-icons/md";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import { Settings as SettingsIcon } from "@mui/icons-material";
import { MdCategory } from "react-icons/md";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Pagination from "@mui/material/Pagination";
import { MyContext } from "../../App";
import Rating from "@mui/material/Rating";
import { Link } from "react-router-dom";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DashboardBox from "../Dashboard/components/dashboardBox";
import SearchBox from "../../components/SearchBox";
import Checkbox from "@mui/material/Checkbox";
import { deleteData, fetchDataFromApi, patchData } from "../../utils/api";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import AdminSettings from "../../components/AdminSettings";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

// breadcrumb code
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

// Dynamic columns based on settings
const getColumns = (isClientVisibilityEnabled, isBulkSelectEnabled) => {
  const baseColumns = [
    { id: "product", label: "PRODUCT", minWidth: 150 },
    { id: "category", label: "CATEGORY", minWidth: 100 },
    { id: "subcategory", label: "SUB CATEGORY", minWidth: 150 },
    { id: "brand", label: "BRAND", minWidth: 130 },
    { id: "price", label: "PRICE", minWidth: 100 },
    { id: "rating", label: "RATING", minWidth: 80 },
    { id: "action", label: "ACTION", minWidth: 120 },
    { id: "status", label: "STATUS", minWidth: 100 },
  ];

  if (isBulkSelectEnabled) {
    baseColumns.unshift({ id: "select", label: "", minWidth: 50 });
  }

  if (isClientVisibilityEnabled) {
    baseColumns.push({ id: "visibility", label: "CLIENT VISIBILITY", minWidth: 150 });
  }

  return baseColumns;
};

const Products = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showBy, setshowBy] = useState(10);
  const [categoryVal, setcategoryVal] = useState("all");
  const [stockStatus, setStockStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState();
  const [totalCategory, setTotalCategory] = useState();
  const [totalSubCategory, setTotalSubCategory] = useState();
  const [isLoadingBar, setIsLoadingBar] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [togglingProducts, setTogglingProducts] = useState(new Set());
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [isClientVisibilityEnabled, setIsClientVisibilityEnabled] = useState(false);
  const [isBulkSelectEnabled, setIsBulkSelectEnabled] = useState(false);
  const open = Boolean(anchorEl);
  const context = useContext(MyContext);

  const [productList, setProductList] = useState([]);
  const [page1, setPage1] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1000);

  // Dialog states for delete confirmation
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  // Multi-select state for bulk delete
  const [selectedProducts, setSelectedProducts] = useState(new Set());
  const [openBulkDialog, setOpenBulkDialog] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);

  const handleOpenDialog = (id) => {
    setSelectedProductId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedProductId(null);
  };

  const handleConfirmDelete = () => {
    if (selectedProductId) {
      deleteProduct(selectedProductId);
    }
    handleCloseDialog();
  };

  // ---- Multi-select handlers ----

  // Toggle a single product's checkbox
  // If the admin disables the "Bulk Product Select & Delete" setting
  // mid-session, drop any in-progress selection.
  useEffect(() => {
    if (!isBulkSelectEnabled && selectedProducts.size > 0) {
      setSelectedProducts(new Set());
    }
  }, [isBulkSelectEnabled]);

  const handleSelectProduct = (id) => {
    setSelectedProducts((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  // "Select all" header checkbox — selects/deselects every product
  // currently visible in filteredProducts (this already respects the
  // active CATEGORY BY filter and STOCK STATUS filter, so choosing a
  // category first and then "select all" only selects that category's products)
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const allIds = (filteredProducts || []).map((item) => item.id);
      setSelectedProducts(new Set(allIds));
    } else {
      setSelectedProducts(new Set());
    }
  };

  const isProductSelected = (id) => selectedProducts.has(id);

  const handleOpenBulkDialog = () => {
    if (selectedProducts.size === 0) return;
    setOpenBulkDialog(true);
  };

  const handleCloseBulkDialog = () => {
    setOpenBulkDialog(false);
  };

  // Delete every selected product, then refresh the list
  const handleConfirmBulkDelete = () => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo?.email !== "rismicmartpvtltd@gmail.com") {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin can delete Product",
      });
      setOpenBulkDialog(false);
      return;
    }

    const idsToDelete = Array.from(selectedProducts);
    if (idsToDelete.length === 0) {
      setOpenBulkDialog(false);
      return;
    }

    context.setProgress(40);
    setIsLoadingBar(true);
    setIsBulkDeleting(true);

    Promise.allSettled(idsToDelete.map((id) => deleteData(`/api/products/${id}`)))
      .then((results) => {
        const failedCount = results.filter((r) => r.status === "rejected").length;
        const successCount = results.length - failedCount;

        context.setProgress(100);

        if (failedCount === 0) {
          context.setAlertBox({
            open: true,
            error: false,
            msg: `${successCount} Product${successCount > 1 ? "s" : ""} Deleted!`,
          });
        } else {
          context.setAlertBox({
            open: true,
            error: true,
            msg: `${successCount} deleted, ${failedCount} failed to delete.`,
          });
        }

        fetchDataFromApi(`/api/products`).then((res) => {
          setProductList(res);
        });
        context.fetchCategory();
        setSelectedProducts(new Set());
        setIsLoadingBar(false);
        setIsBulkDeleting(false);
        setOpenBulkDialog(false);
      })
      .catch(() => {
        context.setProgress(100);
        context.setAlertBox({
          open: true,
          error: true,
          msg: "Something went wrong while deleting products.",
        });
        setIsLoadingBar(false);
        setIsBulkDeleting(false);
        setOpenBulkDialog(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage1(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage1(0);
  };

  // Fetch admin settings with better error handling
  const fetchAdminSettings = async () => {
    try {
      const response = await fetchDataFromApi('/api/admin/settings/client_visibility_toggle_enabled');
      console.log('Admin settings response:', response);
      
      if (response && response.success) {
        setIsClientVisibilityEnabled(response.data.settingValue);
      } else {
        console.log('Setting not found or response failed, defaulting to false');
        setIsClientVisibilityEnabled(false);
      }
    } catch (error) {
      console.error('Error fetching admin settings:', error);
      setIsClientVisibilityEnabled(false);
    }

    try {
      const bulkResponse = await fetchDataFromApi('/api/admin/settings/bulk_product_select_enabled');
      console.log('Bulk select setting response:', bulkResponse);

      if (bulkResponse && bulkResponse.success) {
        setIsBulkSelectEnabled(bulkResponse.data.settingValue);
      } else {
        console.log('Bulk select setting not found or response failed, defaulting to false');
        setIsBulkSelectEnabled(false);
      }
    } catch (error) {
      console.error('Error fetching bulk select setting:', error);
      setIsBulkSelectEnabled(false);
    }
  };

  // Initialize settings with better error handling
  const initializeSettings = async () => {
    try {
      const initResponse = await fetchDataFromApi('/api/admin/settings/initialize');
      console.log('Initialize response:', initResponse);
      // Always try to fetch settings after initialization attempt
      await fetchAdminSettings();
    } catch (error) {
      console.error('Error initializing settings:', error);
      // Still try to fetch existing settings
      await fetchAdminSettings();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    context.setProgress(40);
    // Initialize settings first, then fetch products
    initializeSettings().then(() => {
      fetchDataFromApi(`/api/products`).then((res) => {
        setProductList(res);
        context.setProgress(100);
      });
    });

    fetchDataFromApi("/api/products/get/count").then((res) => {
      setTotalProducts(res.productsCount);
    });

    fetchDataFromApi("/api/category/get/count").then((res) => {
      setTotalCategory(res.categoryCount);
    });

    fetchDataFromApi("/api/category/subCat/get/count").then((res) => {
      setTotalSubCategory(res.categoryCount);
    });
  }, []);

  // Refresh settings when settings dialog closes
  const handleSettingsClose = () => {
    setSettingsOpen(false);
    fetchAdminSettings(); // Refresh settings
  };

  const deleteProduct = (id) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo?.email === "rismicmartpvtltd@gmail.com") {
      context.setProgress(40);
      setIsLoadingBar(true);
      deleteData(`/api/products/${id}`).then((res) => {
        context.setProgress(100);
        context.setAlertBox({
          open: true,
          error: false,
          msg: "Product Deleted!",
        });

        fetchDataFromApi(`/api/products`).then((res) => {
          setProductList(res);
        });
        context.fetchCategory();
        setIsLoadingBar(false);
      });
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin can delete Product",
      });
    }
  };

  const toggleProductVisibility = async (productId, currentVisibility) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo?.email !== "rismicmartpvtltd@gmail.com") {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin can change product visibility",
      });
      return;
    }

    setTogglingProducts(prev => new Set(prev).add(productId));

    try {
      const response = await patchData(`/api/products/${productId}/toggle-visibility`);
      
      if (response && response.success) {
        setProductList(prevState => ({
          ...prevState,
          products: prevState.products.map(product => 
            product.id === productId 
              ? { ...product, isVisibleOnClient: response.data.isVisibleOnClient }
              : product
          )
        }));

        context.setAlertBox({
          open: true,
          error: false,
          msg: `Product ${response.data.isVisibleOnClient ? 'enabled' : 'disabled'} on client page!`,
        });
      } else {
        throw new Error(response?.error || 'Failed to toggle visibility');
      }
    } catch (error) {
      console.error('Error toggling product visibility:', error);
      context.setAlertBox({
        open: true,
        error: true,
        msg: error.message || "Error updating product visibility",
      });
    } finally {
      setTogglingProducts(prev => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  const handleChangeCategory = (event) => {
    setSelectedProducts(new Set()); // clear selection, we're loading a new product set
    if (event.target.value !== "all") {
      setcategoryVal(event.target.value);
      fetchDataFromApi(`/api/products/catId?catId=${event.target.value}`).then(
        (res) => {
          setProductList(res);
          context.setProgress(100);
        }
      );
    } else {
      setcategoryVal("all");
      fetchDataFromApi(`/api/products`).then((res) => {
        setProductList(res);
        context.setProgress(100);
      });
    }
  };

  const searchProducts = (keyword) => {
    setSelectedProducts(new Set()); // clear selection, results are changing
    if (keyword !== "") {
      fetchDataFromApi(`/api/search?q=${keyword}&page=1&perPage=${10000}`).then(
        (res) => {
          setProductList(res);
        }
      );
    } else {
      fetchDataFromApi(`/api/products`).then((res) => {
        setProductList(res);
      });
    }
  };

  const filteredProducts = productList?.products?.filter((item) => {
    if (stockStatus === "in") return item.countInStock > 0;
    if (stockStatus === "out") return item.countInStock <= 0;
    return true;
  });

  // These depend on filteredProducts, so they must be computed after it
  const isAllSelected =
    (filteredProducts?.length || 0) > 0 &&
    filteredProducts.every((item) => selectedProducts.has(item.id));

  const isSomeSelected = selectedProducts.size > 0 && !isAllSelected;

  // Get columns based on current settings
  const columns = getColumns(isClientVisibilityEnabled, isBulkSelectEnabled);

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4 align-items-center">
          <h5 className="mb-0">Product List</h5>
          <div className="ml-auto d-flex align-items-center">
            <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Dashboard"
                icon={<HomeIcon fontSize="small" />}
              />
              <StyledBreadcrumb label="Products" deleteIcon={<ExpandMoreIcon />} />
            </Breadcrumbs>

            {/* Settings Button */}
            <IconButton
              onClick={() => setSettingsOpen(true)}
              sx={{ ml: 1 }}
              title="Admin Settings"
            >
              <SettingsIcon />
            </IconButton>

            <Link to="/product/upload">
              <Button className="btn-blue ml-3 pl-3 pr-3">Add Product</Button>
            </Link>
          </div>
        </div>

        <div className="row dashboardBoxWrapperRow dashboardBoxWrapperRowV2 pt-0">
          <div className="col-md-12">
            <div className="dashboardBoxWrapper d-flex">
              <DashboardBox
                color={["#1da256", "#48d483"]}
                icon={<MdShoppingBag />}
                title="Total Products"
                count={totalProducts}
                grow={true}
              />
              <DashboardBox
                color={["#c012e2", "#eb64fe"]}
                icon={<MdCategory />}
                title="Total Categories"
                count={totalCategory}
              />
              <DashboardBox
                color={["#2c78e5", "#60aff5"]}
                icon={<IoShieldCheckmarkSharp />}
                title="Total Sub Category"
                count={totalSubCategory}
              />
            </div>
          </div>
        </div>

        <div className="card shadow border-0 p-3 mt-4">
          <h3 className="hd">Best Selling Products</h3>

          <div className="row cardFilters mt-2 mb-3">
            <div className="col-md-3">
              <h4>CATEGORY BY</h4>
              <FormControl size="small" className="w-100">
                <Select
                  value={categoryVal}
                  onChange={handleChangeCategory}
                  displayEmpty
                  className="w-100"
                >
                  <MenuItem value="all">
                    <em>All</em>
                  </MenuItem>
                  {context.catData?.categoryList?.map((cat, index) => (
                    <MenuItem className="text-capitalize" value={cat._id} key={index}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-3">
              <h4>STOCK STATUS</h4>
              <FormControl size="small" className="w-100">
                <Select
                  value={stockStatus}
                  onChange={(e) => setStockStatus(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="all">
                    <em>All</em>
                  </MenuItem>
                  <MenuItem value="in">In Stock</MenuItem>
                  <MenuItem value="out">Out of Stock</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 d-flex justify-content-end">
              <div className="searchWrap d-flex">
                <SearchBox searchProducts={searchProducts} />
              </div>
            </div>
          </div>

          {/* Bulk selection toolbar - only shows when the "Bulk Product Select & Delete"
              admin setting is enabled AND at least one product is selected */}
          {isBulkSelectEnabled && selectedProducts.size > 0 && (
            <div
              className="d-flex align-items-center justify-content-between mb-2 p-2"
              style={{
                background: "#fdecea",
                border: "1px solid #f5c6cb",
                borderRadius: 6,
              }}
            >
              <span style={{ fontWeight: 500 }}>
                {selectedProducts.size} product
                {selectedProducts.size > 1 ? "s" : ""} selected
              </span>
              <div className="d-flex align-items-center">
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => setSelectedProducts(new Set())}
                  sx={{ mr: 1 }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  startIcon={<MdDelete />}
                  onClick={handleOpenBulkDialog}
                >
                  Delete Selected
                </Button>
              </div>
            </div>
          )}

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) =>
                      column.id === "select" ? (
                        <TableCell
                          key={column.id}
                          style={{ minWidth: column.minWidth }}
                        >
                          <Checkbox
                            indeterminate={isSomeSelected}
                            checked={isAllSelected}
                            onChange={handleSelectAllClick}
                            inputProps={{ "aria-label": "select all products" }}
                          />
                        </TableCell>
                      ) : (
                        <TableCell
                          key={column.id}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredProducts
                    ?.slice(page1 * rowsPerPage, page1 * rowsPerPage + rowsPerPage)
                    ?.reverse()
                    ?.map((item, index) => (
                      <TableRow
                        key={index}
                        hover
                        selected={isBulkSelectEnabled && isProductSelected(item.id)}
                      >
                        {isBulkSelectEnabled && (
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isProductSelected(item.id)}
                              onChange={() => handleSelectProduct(item.id)}
                              inputProps={{ "aria-label": `select product ${item?.name}` }}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <div className="d-flex align-items-center productBox">
                            <div className="imgWrapper">
                              <div className="img card shadow m-0">
                                <LazyLoadImage
                                  alt={"image"}
                                  effect="blur"
                                  className="w-100"
                                  src={item.images[0]}
                                />
                              </div>
                            </div>
                            <div className="info pl-3">
                              <Link to={`/product/details/${item.id}`}>
                                <h6>{item?.name}</h6>
                              </Link>
                              <p>{item?.description}</p>
                            </div>
                          </div>
                        </TableCell>

                        <TableCell>{item?.catName}</TableCell>
                        <TableCell>{item?.subCatName}</TableCell>
                        <TableCell>
                          <span className="badge badge-secondary">{item?.brand}</span>
                        </TableCell>
                        <TableCell>
                          <div style={{ width: "70px" }}>
                            <del className="old">Rs {item?.oldPrice}</del>
                            <span className="new text-danger d-block w-100">
                              Rs {item?.price}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Rating
                            name="read-only"
                            defaultValue={item?.rating}
                            precision={0.5}
                            size="small"
                            readOnly
                          />
                        </TableCell>
                        <TableCell>
                          <div className="actions d-flex align-items-center">
                            <Link to={`/product/details/${item.id}`}>
                              <Button className="secondary" color="secondary">
                                <FaEye />
                              </Button>
                            </Link>
                            <Link to={`/product/edit/${item.id}`}>
                              <Button className="success" color="success">
                                <FaPencilAlt />
                              </Button>
                            </Link>
                            <Button
                              className="error"
                              color="error"
                              onClick={() => handleOpenDialog(item?.id)}
                            >
                              <MdDelete />
                            </Button>
                          </div>
                        </TableCell>
                        <TableCell>
                          {item.countInStock <= 0 ? (
                            <span className="badge badge-danger">Out of Stock</span>
                          ) : (
                            <span className="badge badge-success">In Stock</span>
                          )}
                        </TableCell>
                        
                        {/* Conditional Client Visibility Column */}
                        {isClientVisibilityEnabled && (
                          <TableCell>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={item.isVisibleOnClient !== undefined ? item.isVisibleOnClient : true}
                                  onChange={() => toggleProductVisibility(item.id, item.isVisibleOnClient)}
                                  disabled={togglingProducts.has(item.id)}
                                  color="primary"
                                />
                              }
                              label={
                                <span style={{ 
                                  fontSize: '12px', 
                                  color: item.isVisibleOnClient !== undefined ? 
                                    (item.isVisibleOnClient ? '#4caf50' : '#f44336') : '#4caf50'
                                }}>
                                  {togglingProducts.has(item.id) ? 'Updating...' : 
                                   (item.isVisibleOnClient !== undefined ? 
                                    (item.isVisibleOnClient ? 'Visible' : 'Hidden') : 'Visible')}
                                </span>
                              }
                              labelPlacement="bottom"
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 100, 500, 1000, 1500, 2000]}
              component="div"
              count={filteredProducts?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-select': {
                  paddingRight: '35px !important',
                },
                '& .MuiSelect-icon': {
                  position: 'absolute',
                  right: '12px',
                  pointerEvents: 'none',
                },
                '& .MuiInputBase-root': {
                  position: 'relative',
                },
              }}
            />
          </Paper>
        </div>

        {/* Admin Settings Dialog */}
        <AdminSettings 
          open={settingsOpen} 
          onClose={handleSettingsClose} 
        />

        {/* Confirmation Dialog */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperProps={{
            sx: { borderRadius: 3, padding: 1 }
          }}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure to delete this product?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              No
            </Button>
            <Button onClick={handleConfirmDelete} color="error" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {/* Bulk Delete Confirmation Dialog */}
        <Dialog
          open={openBulkDialog}
          onClose={handleCloseBulkDialog}
          PaperProps={{
            sx: { borderRadius: 3, padding: 1 }
          }}
        >
          <DialogTitle>Confirm Bulk Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete {selectedProducts.size} selected
              product{selectedProducts.size > 1 ? "s" : ""}? This action cannot
              be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseBulkDialog}
              color="primary"
              disabled={isBulkDeleting}
            >
              No
            </Button>
            <Button
              onClick={handleConfirmBulkDelete}
              color="error"
              autoFocus
              disabled={isBulkDeleting}
            >
              {isBulkDeleting ? "Deleting..." : "Yes, Delete All"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Products;
